import React from "react";

/**
 * Single file preview (image, video or PDF) with a remove button.
 */
const FilePreview = ({ file, onRemove }) => {
  const isImage = file.type.includes("image");
  // Without this branch a PDF falls through to <video> and renders an empty player.
  const isPdf = file.type === "application/pdf";
  return (
    <div className="m-2 border">
      <div className="text-end">
        <button
          type="button"
          className="btn btn-outline-danger btn-sm m-1 py-0"
          onClick={() => onRemove(file.name)}
        >
          x
        </button>
      </div>
      {isImage ? (
        <img
          src={URL.createObjectURL(file)}
          title={file.name}
          alt=""
          height={120}
          width={120}
        />
      ) : isPdf ? (
        <div
          className="d-flex flex-column align-items-center justify-content-center text-center p-2"
          title={file.name}
          style={{ height: 120, width: 120 }}
        >
          <div style={{ fontSize: "1.8rem" }}>📄</div>
          <small
            className="text-muted w-100"
            style={{ wordBreak: "break-all", lineHeight: 1.2 }}
          >
            {file.name}
          </small>
        </div>
      ) : (
        <video
          src={URL.createObjectURL(file)}
          title={file.name}
          height={120}
          width={120}
        />
      )}
    </div>
  );
};

export default FilePreview;
